<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center black--text" outlined>
          模試結果公開設定
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="ml-2" v-bind="attrs" v-on="on" color="orange">mdi-help-circle-outline</v-icon>
            </template>
            <div>学籍システムのHOME模試連携機能にて連携処理を実行すると、</div>
            <div>公開設定として下表に追加されます。</div>
          </v-tooltip>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
        <!-- 検索用の年度入力 -->
        <v-autocomplete
          v-model="selectNendo"
          label="年度指定"
          placeholder="年度指定"
          :items="nendoList"
          @change="reload"
          outlined
          dense
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6">
        <v-autocomplete
          v-model="publisherValue"
          label="発行者指定"
          placeholder="発行者指定"
          :items="publisherList"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-data-table
          :headers="headers"
          :items="reportList"
          :items-per-page.sync="perPage"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          :loading="isLoding" loading-text="読込中"
        >
          <!-- ラベル：連携日付/課程/部/科 -->
          <template #[`header.insDate`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">連携日時</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">課程/部/科</v-col></v-row>
          </template>
          <!-- ラベル：模試名/発行教員/確認教員 -->
          <template #[`header.publisherNm`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">模試名</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">発行教員</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">確認教員</v-col></v-row>
          </template>
          <!-- ラベル：公開状態/設定日時 -->
          <template #[`header.publishStatus`]="{}"> 
            <v-row no-gutters><v-col cols="12" justify="center">公開状態</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">設定日時</v-col></v-row>
          </template>
          <!-- 連携日付/課程・部・科 -->
          <template #[`item.insDate`]="{ item }">
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.insDate }}</v-col></v-row>
            <v-row no-gutters><v-col cols="12" justify="center">{{ item.groupName }}</v-col></v-row>
          </template>
          <!-- 模試名/発行教員/確認教員 -->
          <template #[`item.publisherNm`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">{{ item.mosiNm }}</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">{{ item.publisherNm }}</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">{{ item.confirmerNms }}</v-col></v-row>
          </template>
          <!-- 確認教員変更 -->
          <template #[`item.confirmerChange`]="{ item }">
            <v-tooltip top v-if="item.publisherFlg == true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="openConfirmerModal(item)">変更</v-btn>
              </template>
              <span>模試結果の確認出来る教員を変更する</span>
            </v-tooltip>
            <v-tooltip top v-if="item.publisherFlg == false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :disabled="true">変更</v-btn>
              </template>
              <span>模試結果の確認出来る教員を変更する</span>
            </v-tooltip>
          </template>
          <!-- 公開状態/設定日時 -->
          <template #[`item.publishStatus`]="{ item }">
            <v-row no-gutters v-if="item.studentPublishFlg == true"><v-col cols="12" class="red--text" justify="center">(生徒)公開状況：{{ item.studentPublishStatus }}</v-col></v-row>
            <v-row no-gutters v-if="item.studentPublishFlg == true"><v-col cols="12" class="red--text" justify="center">(生徒)設定日時：{{ item.studentPublishDate }}</v-col></v-row>
            <v-row no-gutters v-if="item.studentPublishFlg == false"><v-col cols="12" justify="center">(生徒)公開状況：{{ item.studentPublishStatus }}</v-col></v-row>
            <v-row no-gutters v-if="item.studentPublishFlg == false"><v-col cols="12" justify="center">(生徒)設定日時：{{ item.studentPublishDate }}</v-col></v-row>            
            <v-row no-gutters v-if="item.parentPublishFlg == true"><v-col cols="12" class="red--text" justify="center">(保護者)公開状況：{{ item.parentPublishStatus }}</v-col></v-row>
            <v-row no-gutters v-if="item.parentPublishFlg == true"><v-col cols="12" class="red--text" justify="center">(保護者)設定日時：{{ item.parentPublishDate }}</v-col></v-row>
            <v-row no-gutters v-if="item.parentPublishFlg == false"><v-col cols="12" justify="center">(保護者)公開状況：{{ item.parentPublishStatus }}</v-col></v-row>
            <v-row no-gutters v-if="item.parentPublishFlg == false"><v-col cols="12" justify="center">(保護者)設定日時：{{ item.parentPublishDate }}</v-col></v-row>
          </template>
          <!-- 生徒公開状態変更 -->
          <template #[`item.publishStatusChange`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">
              <v-tooltip top v-if="item.confirmerFlg == true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="changeStudentStatus(item)">生徒変更</v-btn>
                </template>
                <span>生徒の公開状況を変更する</span>
              </v-tooltip>
              <v-tooltip top v-if="item.confirmerFlg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" :disabled="true">生徒変更</v-btn>
                </template>
                <span>生徒の公開状況を変更する</span>
              </v-tooltip>
            </v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">
              <v-tooltip top v-if="item.confirmerFlg == true">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="changeParentStatus(item)">保護者変更</v-btn>
                </template>
                <span>保護者の公開状況を変更する</span>
              </v-tooltip>
              <v-tooltip top v-if="item.confirmerFlg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" :disabled="true">保護者変更</v-btn>
                </template>
                <span>保護者の公開状況を変更する</span>
              </v-tooltip>
            </v-col></v-row>
          </template>

          <!-- 内容確認 -->
          <template #[`item.action`]="{ item }">
            <v-tooltip top v-if="item.confirmerFlg == true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="openTestGradeModal(item)">確認</v-btn>
              </template>
              <span>模試の結果を確認する</span>
            </v-tooltip>
            <v-tooltip top v-if="item.confirmerFlg == false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :disabled="true">確認</v-btn>
              </template>
              <span>模試の結果を確認する</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
          <v-icon color="white">mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>再読込</span>
    </v-tooltip>

    <!-- 確認教員変更モーダル -->
    <v-dialog
      v-model="confirmerDialog"
      persistent
      max-width="800"
    > 
      <div>
        <v-card
          class="d-flex justify-center flex-column mx-auto flat"
          width="800"
          color="#fff"
        >
          <v-card-subtitle class="d-flex justify-center" white-space="pre">
            <v-row dense>
              <v-col dense cols="4" justify="center">
                <v-btn color="grey" class="black--text" @click="confirmerDialog = false" width="90%">
                  閉じる
                </v-btn>
              </v-col>
              <v-col dense cols="4" justify="center">
                <p>確認教員を更新する</p>
              </v-col>
              <v-col dense cols="4" justify="center">
                <v-btn color="accent" class="black--text" @click="changeConfirmer()" :disabled="invalid" width="90%">
                  更新
                </v-btn>
              </v-col>
            </v-row>
          </v-card-subtitle>
          <v-card-text class="d-flex justify-center flex-column">
            <v-row dense>
              <v-col dense cols="12" justify="center">
                <v-autocomplete
                  v-model="confirmerIds"
                  label="模試結果を確認する教員(自身以外)"
                  placeholder="模試結果を確認する教員(自身以外)"
                  :items="teacherList"
                  outlined
                  dense
                  multiple
                  deletable-chips
                  small-chips
                  hide-details="auto"
                  background-color="white"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>

    <!-- 試験成績確認モーダル -->
    <v-dialog
      v-model="testGradeDialog"
      max-width="1000"
      persistent
    >
      <v-card
        class="d-flex justify-center flex-column mx-auto flat"
        width="1000"
        color="#fff"
      >
        <v-row dense>
          <v-col cols="12" justify="center">
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="testGradeDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>試験結果一覧</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-card-text>
          <v-data-table
            :headers="testGradeHeader"
            :items="testGradeList"
            :items-per-page="-1"
            dense
            disable-sort
            hide-default-footer
          >
            <!-- 氏名/アップロード日時 -->
            <template #[`item.userNm`]="{ item }">
              <v-row no-gutters><v-col cols="12" justify="center">{{ item.userNm }}</v-col></v-row>
              <v-row no-gutters v-if="item.delFlg == true"><v-col cols="12" justify="center">-</v-col></v-row>
              <v-row no-gutters v-if="item.delFlg == false"><v-col cols="12" justify="center">{{ item.uploadDate }}</v-col></v-row>
            </template>
            <!-- 既読状況ボタン -->
            <template #[`item.unreadStatus`]="{ item }">
              <v-row no-gutters><v-col cols="12" justify="center">生徒：{{ item.studentUnreadStatus }}</v-col></v-row>
              <v-row no-gutters><v-col cols="12" justify="center">保護者：{{ item.parentUnreadStatus }}</v-col></v-row>
            </template>
            <!-- 確認状況ボタン -->
            <template #[`item.studentConfirmStatus`]="{ item }">
              <v-row no-gutters><v-col cols="12" justify="center">状況：{{ item.studentConfirmStatus }}</v-col></v-row>
              <v-row no-gutters><v-col cols="12" justify="center">日時：{{ item.studentConfirmDate }}</v-col></v-row>
            </template>
            <!-- 削除ボタン -->
            <template #[`item.result`]="{ item }">
              <v-tooltip bottom v-if="item.delFlg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="onClickView(item)">
                    <v-icon color="black">mdi-file-document-outline</v-icon>
                  </v-btn>
                </template>
                <span>アップロードされた試験結果を確認する。</span>
              </v-tooltip>
            </template>
            <!-- 削除ボタン -->
            <template #[`item.delStatus`]="{ item }">
              <v-tooltip bottom v-if="item.delFlg == false">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" @click="onClickDelete(item)">
                    <v-icon color="black">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>アップロードされた試験結果を削除する。</span>
              </v-tooltip>
              <span class="red--text" v-if="item.delFlg == true">
                {{item.delStatus}}
              </span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- 試験結果表示モーダル -->
    <v-dialog
      v-model="viewGradeDialog"
      max-width="900"
      persistent
    >
      <v-card
        class="d-flex justify-center flex-column mx-auto flat"
        width="900"
        color="#fff"
      >
        <v-row dense>
          <v-col cols="12" justify="center">
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="viewGradeDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>試験結果確認</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-card-text>
          <v-simple-table dense>
            <thead>
              <tr>
                <th cols="4" class="text-left">模試科目</th>
                <th cols="4" class="text-left">区分</th>
                <th cols="4" class="text-left">模試成績</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="subject in moshiRecord" :key="subject.mKamokuNm">
                <td>{{ subject.mKamokuNm }}</td>
                <td>{{ subject.dataKbnNm }}</td>
                <td>{{ subject.mosiSeiseki }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
export default {
  data() {
    return {
      // システム年度
      tounendo: "",
      selectNendo: "",
      nendoList : [],
      publisherValue: "",
      publisherList : [],
      headers : [
        { text: "連携日時/課程・部・科", value: "insDate" , width: "250" },
        { text: "模試名/発行教員/確認教員", value: "publisherNm" , width: "250", filter: this.teacherFilter }, 
        { text: "確認教員変更", value: "confirmerChange" , width: "100" },
        { text: "公開状況", value: "publishStatus" , width: "250" }, 
        { text: "公開状況設定", value: "publishStatusChange" , width: "80" },
        { text: "内容確認", value: "action", width: "80" },
      ],
      reportList: [],
      isLoding: false,
      // 更新用パラメータ
      nendo: "",
      kbk: "",
      mosiCd: "",
      // 確認教員更新ダイアログ用
      confirmerDialog: false,
      confirmerIds: [],
      teacherList:[],

      // 模試単位での結果一覧ダイアログ用
      testGradeDialog: false,
      testGradeHeader: [
        { text: "学年", value: "gakunen" , width: "60" },
        { text: "学級", value: "gakkyu" , width: "60" },
        { text: "出席番号", value: "syussekiNo" , width: "60" },
        { text: "氏名/アップロード日時", value: "userNm" , width: "280" },
        { text: "既読状況", value: "unreadStatus" , width: "120" },
        { text: "生徒確認", value: "studentConfirmStatus" , width: "120" },
        { text: "内容確認", value: "result" , width: "80" },
        { text: "削除", value: "delStatus" , width: "80" },
      ],
      testGradeList: [],
      perPage: 30,

      // 成績表示モーダル用
      viewGradeDialog: false,
      moshiRecord : [],
    };
  },
  // 初期表示時データ読み込み
  async created() {
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
    await schoolAidHomeLogined({funcName: "commonGetNendo"}).then((ret) => {
      this.tounendo = ret.data.tounendo;
      // 検索条件の年度に初期設定
      this.selectNendo = ret.data.tounendo;
      this.nendoList = ret.data.list;
    });

    // 確認教員変更モーダル用
    await schoolAidHomeLogined({funcName: "commonGetTeachers", includeFlg: false}).then((ret) => {
      this.teacherList = ret.data.teacherList;
    })

    await this.reload();
  },
  methods: {
    // 発行者名フィルタ
    teacherFilter(value) {
      if (!this.publisherValue) {
        return true;
      }
      return value.includes(this.publisherValue);
    },
    // リスト読込
    async reload() {
      // 結果格納用配列
      this.reportList = [];
      // 条件格納用配列
      var temp_teachers = new Set();
      // 検索処理
      this.isLoding = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = {
        funcName : "loadPracticeExamSetting",
        nendo : this.selectNendo,
      }
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        // 発行者の名前をリスト化
        ret.data.forEach((row) => {
          temp_teachers.add(row.publisherNm);
        });
        this.reportList = ret.data;
        this.isLoding = false;
      });
      this.publisherList = Array.from(temp_teachers);
    },
    // 確認教員変更モーダルを表示する
    openConfirmerModal(item) {
      this.confirmerIds = item.confirmerIds;
      this.nendo = item.nendo;
      this.kbk = item.kbk;
      this.mosiCd = item.mosiCd;
      this.confirmerDialog = true;
    },
    // 確認教員を変更する
    async changeConfirmer() {
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName:"updatePracticeExamSettingConfirmerId",
        nendo: this.nendo,
        kbk: this.kbk,
        mosiCd: this.mosiCd,
        confirmerIds: this.confirmerIds,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        console.log(ret);
      });
      this.confirmerDialog = false;
      await this.reload();
    },
    // 生徒状態更新
    async changeStudentStatus(item){
      var result = confirm("生徒の公開状態を変更してよろしいですか？");
      if (!result) {
        return;
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName:"changePracticeExamSettingStudent",
        nendo: item.nendo,
        kbk: item.kbk,
        mosiCd: item.mosiCd,
        publishFlg: item.studentPublishFlg,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        item.studentPublishFlg = ret.data.publishFlg;
        item.studentPublishStatus = ret.data.publishStatus;
        item.studentPublishDate = ret.data.publishDate;
      });
    },
    // 保護者状態更新
    async changeParentStatus(item){
      var result = confirm("保護者の公開状態を変更してよろしいですか？");
      if (!result) {
        return;
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName:"changePracticeExamSettingParent",
        nendo: item.nendo,
        kbk: item.kbk,
        mosiCd: item.mosiCd,
        publishFlg: item.parentPublishFlg,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        item.parentPublishFlg = ret.data.publishFlg;
        item.parentPublishStatus = ret.data.publishStatus;
        item.parentPublishDate = ret.data.publishDate;
      });
    },
    // 試験成績一覧をモーダルで表示する
    async openTestGradeModal(item) {
      // 試験結果削除のために退避
      this.nendo = item.nendo;
      this.kbk = item.kbk;
      this.mosiCd = item.mosiCd;

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName:"loadMoshiGradeList",
        nendo: item.nendo,
        kbk: item.kbk,
        mosiCd: item.mosiCd,
      }
      this.testGradeList = [];
      await schoolAidHomeLogined(param).then((ret) => {
        this.testGradeList = ret.data;
      });
      this.testGradeDialog = true;
    },
    // 試験結果確認
    async onClickView(item){
      this.resetGrade();
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName: "viewMoshiGrade",
        nendo: this.nendo,
        kbk: this.kbk,
        mosiCd: this.mosiCd,
        userId: item.userId,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        this.moshiRecord = ret.data.moshiRecordSet;
        this.viewGradeDialog = true;
      });
    },
    // 試験結果削除
    async onClickDelete(item){
      var result = confirm("アップロードされた試験結果を削除してよろしいですか？");
      if (!result) {
        return;
      }
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      var param = {
        funcName:"deleteMoshiGrade",
        nendo:this.nendo,
        kbk: this.kbk,
        mosiCd:this.mosiCd,
        userId:item.userId,
      }
      await schoolAidHomeLogined(param).then((ret) => {
        item.delFlg = ret.data.delFlg;
        item.delStatus = ret.data.delStatus;
      });
    },
    resetGrade(){
      this.moshiRecord = [];
    },
  },
};
</script>

<style scoped>
.modal-header, .modal-body {
  padding: 5px 25px;
}
.modal-header {
  border-bottom: 1px solid #ddd;
}

</style>